import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  LuMessageSquarePlus,
  LuCreditCard,
  LuWallet,
  LuLink,
  LuRepeat,
  LuChevronDown,
} from 'react-icons/lu';
import { Col, Container, Row } from 'react-bootstrap';

import { isFeatureEnabled } from 'helpers';
import { Button, Dropdown } from '_components/_core';

import {
  Notifications,
  PaymentGateways,
  PaymentMethods,
  PaymentMethodGateway,
  ChargeStatus,
  ChargeStatusPaymentGateway,
  BillingOverview,
} from './components';

function Admin({ user }) {
  const [activeTab, setActiveTab] = useState('notifications');

  const tabs = [
    {
      id: 'billing-overview',
      title: 'Assinaturas',
      icon: <LuRepeat className="mr-2" />,
    },
    {
      id: 'notifications',
      title: 'Notificações',
      icon: <LuMessageSquarePlus className="mr-2" />,
    },
    {
      id: 'payment-gateways',
      title: 'Gateways de Pagamento',
      icon: <LuCreditCard className="mr-2" />,
    },
    {
      id: 'payment-methods',
      title: 'Métodos de Pagamento',
      icon: <LuWallet className="mr-2" />,
    },
    {
      id: 'payment-method-gateway',
      title: 'Assoc. de Métodos de Pagamento',
      icon: <LuLink className="mr-2" />,
    },
    {
      id: 'charge-status',
      title: 'Status de Pagamento',
      icon: <LuWallet className="mr-2" />,
    },
    {
      id: 'charge-status-payment-gateway',
      title: 'Assoc. de Status de Pagamento',
      icon: <LuLink className="mr-2" />,
    },
  ];

  const handleTabChange = tab => {
    setActiveTab(tab);
  };

  if (!isFeatureEnabled('superadmin', user.flags)) {
    return null;
  }

  return (
    <Container fluid>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="m-0 p-0">Administrador</h4>
        <div>
          <Dropdown
            placement="bottom-end"
            options={[
              {
                label: 'Assinaturas',
                onClick: () => handleTabChange('billing-overview'),
                icon: <LuRepeat className="mr-2" />,
              },
              {
                label: 'Notificações',
                onClick: () => handleTabChange('notifications'),
                icon: <LuMessageSquarePlus className="mr-2" />,
              },
              {
                label: 'Gateways de Pagamento',
                onClick: () => handleTabChange('payment-gateways'),
                icon: <LuCreditCard className="mr-2" />,
              },
              {
                label: 'Métodos de Pagamento',
                onClick: () => handleTabChange('payment-methods'),
                icon: <LuWallet className="mr-2" />,
              },
              {
                label: 'Assoc. de Métodos',
                onClick: () => handleTabChange('payment-method-gateway'),
                icon: <LuLink className="mr-2" />,
              },
              {
                label: 'Status de Pagamento',
                onClick: () => handleTabChange('charge-status'),
                icon: <LuWallet className="mr-2" />,
              },
              {
                label: 'Assoc. de Status',
                onClick: () => handleTabChange('charge-status-payment-gateway'),
                icon: <LuLink className="mr-2" />,
              },
            ]}
          >
            <Button
              variant="white"
              className="d-flex align-items-center justify-content-between"
            >
              <>
                {tabs.find(tab => tab.id === activeTab).title}
                <LuChevronDown size={20} className="ml-2" />
              </>
            </Button>
          </Dropdown>
        </div>
      </div>
      <Row>
        <Col lg={12}>
          {activeTab === 'billing-overview' && <BillingOverview />}
          {activeTab === 'notifications' && <Notifications />}
          {activeTab === 'payment-gateways' && <PaymentGateways />}
          {activeTab === 'payment-methods' && <PaymentMethods />}
          {activeTab === 'payment-method-gateway' && <PaymentMethodGateway />}
          {activeTab === 'charge-status' && <ChargeStatus />}
          {activeTab === 'charge-status-payment-gateway' && (
            <ChargeStatusPaymentGateway />
          )}
        </Col>
      </Row>
    </Container>
  );
}

Admin.propTypes = {
  onCreateSingleNotification: PropTypes.func.isRequired,
};

export default Admin;
